/** Canonical paths for legal documents (all under `/legal/`). */
export const LEGAL_ROUTES = {
  hub: "/legal",
  terms: "/legal/terms",
  privacy: "/legal/privacy",
  cookies: "/legal/cookies",
  noSale: "/legal/no-sale",
} as const;
